import { useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';

import { InputBackOffice } from '../../components/common/InputBackoffice';
import { FlexBetween, Label } from '../../styles/stylesStyled';
import { useState } from 'react';
import { Button, ErrorToast } from '../../components';
import { useDispatch } from 'react-redux';
import {
  createWebinarMenagement,
  purchaseWebinarTicket
} from '../../slices/webinars-slice';
import { P3 } from '../../styles/FontStyles';
import { color, colors } from '../../styles/GlobalStyles';
import { SelectToken } from '../../components/common/SelectNetwork/SelectToken';
import { SelectedUSDT } from '../../styles/GlobalComponents';
import { useTranslation } from 'react-i18next';
import { copyLink, formatUSD } from '../../helpers/helperFunctions';
import wallet from '../../assets/icons/backOffice/Packages/wallet.svg';
import { ORDERS } from '../../routes/routes';
import { useHistory } from 'react-router';

const Success = ({
  currency
}: {
  selectedToken: any;
  selectedWebinar: any;
  currency: string;
}) => {
  const history = useHistory();
  const { t } = useTranslation('packages');

  const { webinar } = useAppSelector((state) => state.webinars);

  return (
    <>
      <div>
        <P3 mb='8' color={colors.neutral900}>
          {t('waiting.text1')}
        </P3>

        <P3 mb='8' mt='20' color={colors.neutral900}>
          {t('waiting.text2')}
        </P3>

        <P3 mb='8' mt='20' color={colors.neutral900}>
          {t('waiting.text3')}
        </P3>

        <P3 bold mb='8' mt='20' color={colors.neutral900}>
          {t('waiting.payment_amount')}
        </P3>

        <SelectedUSDT>{formatUSD(webinar?.totalAmount)}</SelectedUSDT>

        <P3 bold mb='8' mt='20' color={colors.neutral900}>
          Selected {t('waiting.network')}
        </P3>

        <SelectedUSDT>Binance Smart Chain (BEP-20)</SelectedUSDT>

        <P3 bold mb='8' mt='20' color={colors.neutral900}>
          Selected Token
        </P3>

        <SelectedUSDT>{currency}</SelectedUSDT>

        <P3 bold mb='8' mt='20' color={colors.neutral900}>
          {t('waiting.wallet_address')}
        </P3>

        <SelectedUSDT
          onClick={() => {
            copyLink(webinar?.walletAddress, t('waiting.copied'));
          }}
          style={{ cursor: 'pointer' }}>
          <div className='truncated'>
            <div>{webinar?.walletAddress}</div>
          </div>

          <img
            src={wallet}
            alt='withdraw'
            style={{ width: 16, marginLeft: 10 }}
          />
        </SelectedUSDT>
        <Button mt='30' onClick={() => history.push(ORDERS)}>
          Close
        </Button>
      </div>

      {/* <SelectToken
        onChange={(token) => {
          setSelectedToken(token);
        }}
        value={selectedToken}
      />

      <Button
        onClick={() =>
          dispatch(
            purchaseWebinarTicket({
              webinarId: selectedWebinar?.id,
              token: selectedToken.token,
              setStep
            })
          )
        }>
        Purchase Ticket
      </Button> */}
    </>
  );
};

export default Success;
